<template>
  <BoundingBox
    v-if="
      attachment.type === attachmentTypes.BOUNDING_BOX &&
      attachment.is_verified &&
      message.messageWriter
    "
    :message="message"
    :attachment="attachment"
  />
  <Iframe
    v-else-if="
      attachment.type === attachmentTypes.IFRAME && message.messageWriter
    "
    :message="message"
    :attachment="attachment"
  />
  <Policy
    v-else-if="
      attachment.type === attachmentTypes.LINK && message.messageWriter
    "
    :message="message"
    :attachment="attachment"
  />
  <Image
    v-else-if="
      attachment.type === attachmentTypes.IMAGE && message.messageWriter
    "
    :message="message"
    :attachment="attachment"
  />

  <AudioPlayer
    v-else-if="attachment.type === attachmentTypes.VOICE && attachment.link"
    :message="message"
    :attachment="attachment"
  />

  <Stream
    v-else-if="attachment.type === attachmentTypes.STREAM"
    :message="message"
    :attachment="attachment"
  />
  <Animation
    v-else-if="
      attachment.type === attachmentTypes.ANIMATION && message.messageWriter
    "
    :message="message"
    :attachment="attachment"
  />
</template>
<script setup>
  import Iframe from "@/pages/components/messages/attachment/Iframe.vue"
  import Policy from "@/pages/components/messages/attachment/Policy.vue"
  import Image from "@/pages/components/messages/attachment/Image.vue"
  import AudioPlayer from "@/pages/components/messages/attachment/AudioPlayer.vue"
  import Stream from "@/pages/components/messages/attachment/Stream.vue"
  import Animation from "@/pages/components/messages/attachment/Animation.vue"
  import BoundingBox from "@/pages/components/messages/attachment/BoundingBox.vue"

  import { attachmentTypes } from "@/utils/enums"
  import { ref, onMounted } from "vue"

  const props = defineProps({
    message: {
      type: Object,
      required: false,
      default: {},
    },
    attachment: {
      type: Object,
      required: false,
      default: {},
    },
  })
</script>
